import { render } from "./productsalesreport.vue?vue&type=template&id=245cf443&scoped=true"
import script from "./productsalesreport.vue?vue&type=script&lang=js"
export * from "./productsalesreport.vue?vue&type=script&lang=js"

import "./productsalesreport.vue?vue&type=style&index=0&id=245cf443&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245cf443"]])

export default __exports__